import { render } from "./ObservationDetail.vue?vue&type=template&id=9c8c3c5c&scoped=true"
import script from "./ObservationDetail.vue?vue&type=script&lang=js"
export * from "./ObservationDetail.vue?vue&type=script&lang=js"

import "./ObservationDetail.vue?vue&type=style&index=0&id=9c8c3c5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c8c3c5c"]])

export default __exports__